import BaseComponent from 'foundation/base-component';
import app from 'general/js/app';

const DEFAULT_GROUP_NAME = 'Default';

class ContextualManagerComponent extends BaseComponent {
    constructor(...args) {
        super(...args);
        this.state = {
            minToShowCount: this.options.minToShowCount || 0,
            mainCount: 0,
            replacementCount: this.getReplacementCount(),
            groups: {}
        };

        if (!app.isEditMode) {
            this.init();
        }
    }

    init() {
        if (Array.isArray(this.refs.main)) {
            this.splitMainToGroups();
            this.state.mainCount = this.getMainCount();
            this.showMain();
        }

        if (this.state.mainCount < this.options.minToShowCount) {
            this.showReplacement();
        }
    }

    splitMainToGroups() {
        this.refs.main.forEach((ref) => {
            const groupName = this.getAttribute(ref, 'group');

            if (!groupName) return;

            if (!this.state.groups[groupName]) {
                this.state.groups[groupName] = [];
            }

            this.state.groups[groupName].push(ref);
        });
    }

    getMainCount() {
        const totalRefs = this.refs.main.length;
        const totalRefsInGroups = Object.keys(this.state.groups).reduce((prev, groupName) => {
            if (groupName === DEFAULT_GROUP_NAME) return prev;
            //eslint-disable-next-line no-return-assign
            return prev += this.state.groups[groupName].length;
        }, 0);
        const totalGroups = Object.keys(this.state.groups).length - 1;

        return totalRefs - totalRefsInGroups + totalGroups;
    }

    getReplacementCount() {
        return (this.refs.replacement && this.refs.replacement.length) || 0;
    }

    // this is bad but there is no way to set ref on a wrapper in Sitecore way :(
    makeVisible(ref) {
        const hiddenWrapper = ref.closest('.is-hidden');

        if (hiddenWrapper) {
            hiddenWrapper.classList.remove('is-hidden');
        }
    }

    showRandomInGroup(group) {
        const randomIndex = Math.round(Math.random() * (group.length - 1));
        this.makeVisible(group[randomIndex]);
    }

    showMain() {
        Object.keys(this.state.groups).forEach((groupName) => {
            const group = this.state.groups[groupName];

            if (groupName === DEFAULT_GROUP_NAME) {
                group.forEach((ref) => this.makeVisible(ref));
            } else {
                this.showRandomInGroup(group);
            }
        });
    }

    showReplacement() {
        if (!Array.isArray(this.refs.replacement)) return;

        let replacementStack = [...this.refs.replacement];
        let diff = this.state.minToShowCount - this.state.mainCount;

        while (replacementStack.length > 0 && diff > 0) {
            const randomIndex = Math.round(Math.random() * (replacementStack.length - 1));
            const replacementRef = replacementStack[randomIndex];

            replacementStack = replacementStack.filter((ref, index) => index !== randomIndex);

            if (replacementRef) {
                this.makeVisible(replacementRef);
            }
            diff--;
        }
    }
}

export default ContextualManagerComponent;
